// @flow

import { getApi } from './api.core'

export const getAllFiles = params =>
  getApi('api/email-thread/all-files/', params)
export const getAllArchivedFiles = params =>
  getApi('api/archived/email-thread/all-files/', params)
